export const itemsByCategory = {
    warehouse: {
        items: ['a', 'b', 'c', 'd']
    },
    building: {
        items: ['a', 'aPlus', 'b', 'bPlus', 'bMinus', 'c']
    },
    industry: {
        items: ['a', 'b', 'c', 'd']
    },
    office: {
        items: ['a', 'aPlus', 'b', 'bPlus', 'bMinus', 'c']
    },
    shoppingArea: {
        items: ['a', 'aPlus', 'b', 'bPlus', 'bMinus', 'c']
    },
    default: {
        items: ['a', 'b', 'bPlus', 'c', 'cPlus']
    }
};

export default [{
    text: 'A',
    value: 'a',
}, {
    text: 'A+',
    value: 'aPlus',
}, {
    text: 'B+',
    value: 'bPlus',
}, {
    text: 'B',
    value: 'b',
}, {
    text: 'B-',
    value: 'bMinus',
}, {
    text: 'C+',
    value: 'cPlus',
}, {
    text: 'C',
    value: 'c',
}, {
    text: 'D',
    value: 'd',
}];
